package com.eladfinish.bible.contest.screens.search

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.input.TextFieldValue
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.ads.ShouldShowAdsUseCase
import com.eladfinish.bible.contest.analytics.providers.AnalyticsProvider
import com.eladfinish.bible.contest.arch.ViewModelStore
import com.eladfinish.bible.contest.clear_text
import com.eladfinish.bible.contest.common.gender.getHebrewGender
import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.copy_options
import com.eladfinish.bible.contest.copy_search_result
import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.data.common.MyClipboardManager
import com.eladfinish.bible.contest.di.config.DebugInfo
import com.eladfinish.bible.contest.domain.BooksRepository.bookNamesHebrew
import com.eladfinish.bible.contest.exporting_to_file
import com.eladfinish.bible.contest.expression_to_be_searched_format
import com.eladfinish.bible.contest.extensions.formatWithCommas
import com.eladfinish.bible.contest.features.copyOptions.model.CopyOptionsConfig
import com.eladfinish.bible.contest.features.copyOptions.model.CopyOptionsInput
import com.eladfinish.bible.contest.features.copyOptions.model.CopyOptionsOperation
import com.eladfinish.bible.contest.features.deeplink.DeepLinks
import com.eladfinish.bible.contest.features.review.ReviewMoment
import com.eladfinish.bible.contest.features.review.ReviewPrompter
import com.eladfinish.bible.contest.file_saved_successfully
import com.eladfinish.bible.contest.file_was_not_saved
import com.eladfinish.bible.contest.models.ClickableTextData
import com.eladfinish.bible.contest.no_search_results
import com.eladfinish.bible.contest.platform.dispatchers.IoDispatcher
import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfig
import com.eladfinish.bible.contest.screens.search.ai.AiSearchSuggestion
import com.eladfinish.bible.contest.screens.search.analytics.SearchAnalyticsEventFactory
import com.eladfinish.bible.contest.screens.search.analytics.SearchAnalyticsTracker
import com.eladfinish.bible.contest.screens.search.history.RecordSearchHistoryUseCase
import com.eladfinish.bible.contest.screens.search.history.SearchHistoryHint
import com.eladfinish.bible.contest.screens.search.history.SearchHistoryKind
import com.eladfinish.bible.contest.screens.search.history.SearchHistoryRepository
import com.eladfinish.bible.contest.screens.search.history.SearchHistorySort
import com.eladfinish.bible.contest.screens.search.history.restoredFrom
import com.eladfinish.bible.contest.screens.search.history.startsSearch
import com.eladfinish.bible.contest.screens.search.model.HorizontalDirection
import com.eladfinish.bible.contest.screens.search.model.LocalSearchResult
import com.eladfinish.bible.contest.screens.search.model.SearchDebugContext
import com.eladfinish.bible.contest.screens.search.model.SearchMode
import com.eladfinish.bible.contest.screens.search.model.SearchNumberOrRoot
import com.eladfinish.bible.contest.screens.search.model.SearchPlace
import com.eladfinish.bible.contest.screens.search.model.SearchPlaceData
import com.eladfinish.bible.contest.screens.search.model.VerseUiModel
import com.eladfinish.bible.contest.screens.search.model.countResultsByBook
import com.eladfinish.bible.contest.screens.search.model.jumpToFirstResultOf
import com.eladfinish.bible.contest.screens.search.mvi.AutocompleteUiState
import com.eladfinish.bible.contest.screens.search.mvi.SearchAction
import com.eladfinish.bible.contest.screens.search.mvi.SearchEffect
import com.eladfinish.bible.contest.screens.search.mvi.SearchState
import com.eladfinish.bible.contest.screens.search.mvi.completeSearch
import com.eladfinish.bible.contest.screens.search.mvi.initialOnlyQri
import com.eladfinish.bible.contest.screens.search.suggestions.AutocompleteSuggestion
import com.eladfinish.bible.contest.screens.search.suggestions.GetAutocompleteSuggestionsUseCase
import com.eladfinish.bible.contest.screens.search.suggestions.PopularSearchesFilter
import com.eladfinish.bible.contest.screens.search.suggestions.SuggestionsPage
import com.eladfinish.bible.contest.screens.search.usecases.NavigateToAdjacentChapterUseCase.Companion.ChapterDirection
import com.eladfinish.bible.contest.screens.search.usecases.date.DateQuery
import com.eladfinish.bible.contest.screens.search.usecases.engine.model.PrepareLocalSearchRequestInput
import com.eladfinish.bible.contest.screens.search.usecases.engine.model.PrepareLocalSearchRequestResult
import com.eladfinish.bible.contest.screens.search.usecases.facts.SpecialSearchResult
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.SearchFact
import com.eladfinish.bible.contest.search_progress_format
import com.eladfinish.bible.contest.search_progress_special_search_format
import com.eladfinish.bible.contest.search_results
import com.eladfinish.bible.contest.search_results_placeholder
import com.eladfinish.bible.contest.search_summary_format
import com.eladfinish.bible.contest.text.SpanType
import com.eladfinish.bible.contest.text.SpannedRange
import com.eladfinish.bible.contest.ui.menus.actions.SearchToolbarAction
import com.eladfinish.bible.contest.usecase.GetRemoteConfigValueUseCase
import com.eladfinish.bible.contest.utils.addGershaim
import com.eladfinish.bible.contest.utils.toOtiot
import com.eladfinish.contract.analytics.SearchSource
import com.russhwolf.settings.Settings
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.desc.desc
import dev.icerock.moko.resources.format
import kotlinx.atomicfu.atomic
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.toImmutableList
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.withContext
import kotlin.contracts.ExperimentalContracts
import kotlin.contracts.InvocationKind
import kotlin.contracts.contract
import kotlin.time.TimeMark
import kotlin.time.TimeSource

class SearchStore(
    remoteConfig: GetRemoteConfigValueUseCase,
    private val searchAnalyticsTracker: SearchAnalyticsTracker,
    private val searchAnalyticsEventFactory: SearchAnalyticsEventFactory,
    private val searchUseCaseProvider: SearchUseCaseProvider,
    private val analyticsProvider: AnalyticsProvider,
    private val myClipboardManager: MyClipboardManager,
    private val debugInfo: DebugInfo,
    private val settings: Settings,
    private val shouldShowAdsUseCase: ShouldShowAdsUseCase,
    private val searchHistoryRepository: SearchHistoryRepository,
    private val recordSearchHistoryUseCase: RecordSearchHistoryUseCase,
    private val searchHistoryHint: SearchHistoryHint,
    private val reviewPrompter: ReviewPrompter,
    private val getAutocompleteSuggestionsUseCase: GetAutocompleteSuggestionsUseCase,
) : ViewModelStore<SearchState, SearchAction, SearchEffect>(
    tag = "SearchStore",
) {

    companion object {
        const val SKIP_READ_ME_PREF = "skipReadMeSearch"
    }

    private var searchStartTimeMark: TimeMark? = null

    private var historySort = SearchHistorySort.RECENT

    // Where the expression in the field came from, when the user did not type it: a history
    // row, a suggestion, a guide example, a link, the AI. Cleared as soon as the user edits the
    // field, and reported with the search that runs it (SearchAnalyticsEvent.source), so the
    // popular-searches snapshot can count only what users came up with themselves.
    private var pendingSearchSource: String? = null

    // The source of the search that is running, for the analytics event sent when it ends.
    private var runningSearchSource: String = SearchSource.TYPED

    // Set immediately on cancel, before entering the dispatch queue, so the search loop
    // detects cancellation without waiting for all queued progress/result dispatches to drain.
    private val immediateKeepRunning = atomic(true)

    // Bumped every time a new search starts. Each run captures its generation; results and
    // completions from a superseded run are ignored, so a rapid second search (e.g. a
    // double-tap on the search button) can't merge two runs' identically-keyed results into
    // one LazyColumn and crash with a duplicate-key IllegalArgumentException. Atomic because
    // the running search loop reads it from IoDispatcher.
    private val searchGeneration = atomic(0)

    override fun dispatch(action: SearchAction) {
        if (action is SearchAction.StopSearching) {
            immediateKeepRunning.value = false
        }
        super.dispatch(action)
    }

    private val durationMs: Long
        get() = searchStartTimeMark
            ?.elapsedNow()
            ?.inWholeMilliseconds
            ?: 0L

    init {
        analyticsProvider.logEvent(
            event = "SearchScreen",
        )
    }

    private val isSkipReadMeChecked: Boolean
        get() = settings.getBoolean(key = SKIP_READ_ME_PREF, defaultValue = false)

    private val defaultState = SearchState(
        isSkipReadMeChecked = isSkipReadMeChecked,
        specialSigns = searchUseCaseProvider.getSpecialSignsUseCase(),
        searchMode = SearchMode.valueOf(
            settings.getString(
                key = Constants.PREF_SEARCH_MODE,
                defaultValue = SearchMode.REGULAR_SEARCH.name,
            ),
        ),
        onlyQri = initialOnlyQri(settings),
        shouldShowAiSearch = remoteConfig.get<Boolean>(RemoteConfig.FEATURE_FLAG_AI_SEARCH) ?: false,
        isDebugUser = debugInfo.isDebugMode,
        hebrewGender = settings.getHebrewGender(),
        isSearchSuggestionsEnabled = getAutocompleteSuggestionsUseCase.isEnabled,
        suggestionsPage = if (getAutocompleteSuggestionsUseCase.isEnabled) SuggestionsPage.HOT_NOW else SuggestionsPage.RESULTS,
        dialogState = if (isSkipReadMeChecked) {
            SearchState.DialogState.None
        } else {
            SearchState.DialogState.Help(
                helpDialogClickableTextData = getSearchHelpContent(),
                isDontShowAgainChecked = isSkipReadMeChecked,
            )
        },
    )

    override val stateFlow = MutableStateFlow(defaultState)

    init {
        // The one-time "saved to history" hint waits for the search to end: until then the
        // progress dialog would cover it.
        launchEffect {
            stateFlow
                .map { it.isSearching }
                .distinctUntilChanged()
                .collect { isSearching ->
                    if (!isSearching && searchHistoryHint.shouldShowWhenSearchEnds()) {
                        sideEffectFlow.emit(SearchEffect.ShowHistorySavedHint)
                    }
                }
        }

        if (defaultState.isSearchSuggestionsEnabled) {
            launchEffect {
                getAutocompleteSuggestionsUseCase.refreshIfStale()
            }
            loadPopularLists()
        }
    }

    override fun handleAction(action: SearchAction): SearchState =
        when (action) {
            // Input
            is SearchAction.Initialize -> handleInitialize(action)
            is SearchAction.TextFieldValueChanged -> handleTextFieldValueChanged(action)
            SearchAction.ClearClicked -> handleClearClicked()
            SearchAction.ClearLongClicked -> handleClearLongClicked()
            is SearchAction.SignClicked -> handleSignClicked(action)
            is SearchAction.SignLongClicked -> handleSignLongClicked(action)
            is SearchAction.HorizontalArrowClicked -> handleHorizontalArrowClicked(action)
            is SearchAction.HorizontalArrowLongClicked -> handleHorizontalArrowLongClicked(action)

            // Search execution
            SearchAction.SearchClicked -> handleSearchClicked()
            SearchAction.SearchLongClicked -> handleSearchLongClicked()
            SearchAction.StopSearching -> handleStopSearching()
            is SearchAction.SearchProgressChanged -> handleSearchProgressChanged(action)
            is SearchAction.SearchResultsFound -> handleSearchResultsFound(action)
            is SearchAction.SearchCompleted -> handleSearchCompleted(action)
            is SearchAction.SearchFailed -> handleSearchFailed(action)
            is SearchAction.SearchSuggestionFound -> handleSearchSuggestionFound(action)

            // Results
            is SearchAction.ResultClicked -> handleResultClicked(action)
            is SearchAction.ResultLongClicked -> handleResultLongClicked(action)
            SearchAction.ResultsByBookClicked -> handleResultsByBookClicked()
            is SearchAction.ResultsByBookItemClicked -> handleResultsByBookItemClicked(action)
            SearchAction.ResultsJumpHandled -> currentState.copy(resultsJump = null)
            SearchAction.ShowPreviousChapter -> handleShowPreviousChapter()
            SearchAction.ShowNextChapter -> handleShowNextChapter()

            // Toolbar / menu
            is SearchAction.ToolbarClicked -> handleToolbarClicked(action)
            is SearchAction.InterestingFactClicked -> handleInterestingFactClicked(action.searchFact)
            is SearchAction.SaveFile -> handleSaveFile(action.content)

            // History
            is SearchAction.HistoryLoaded -> handleHistoryLoaded(action)
            is SearchAction.HistorySortChanged -> handleHistorySortChanged(action)
            is SearchAction.HistoryEntryClicked -> handleHistoryEntryClicked(action)
            is SearchAction.HistoryEntryDeleteClicked -> handleHistoryEntryDeleteClicked(action)
            SearchAction.ClearHistoryClicked -> handleClearHistoryConfirmation(isConfirming = true)
            SearchAction.ClearHistoryCancelled -> handleClearHistoryConfirmation(isConfirming = false)
            SearchAction.ClearHistoryConfirmed -> handleClearHistoryConfirmed()

            // Autocomplete
            is SearchAction.AutocompleteLoaded -> handleAutocompleteLoaded(action)
            is SearchAction.PopularListsLoaded -> handlePopularListsLoaded(action)
            is SearchAction.SuggestionsPageSelected -> handleSuggestionsPageSelected(action)
            is SearchAction.AutocompleteSuggestionClicked -> handleAutocompleteSuggestionClicked(action)
            is SearchAction.AutocompleteSuggestionFillClicked -> handleAutocompleteSuggestionFillClicked(action)
            is SearchAction.MoreSuggestionsClicked -> handleMoreSuggestionsClicked(action)

            // Popular searches
            is SearchAction.PopularSearchesLoaded -> handlePopularSearchesLoaded(action)
            is SearchAction.PopularSearchesFilterChanged -> handlePopularSearchesFilterChanged(action)
            is SearchAction.PopularSearchClicked -> handlePopularSearchClicked(action)
            is SearchAction.PopularSearchLongClicked -> handlePopularSearchLongClicked(action)

            // Nikud / Teamim section
            SearchAction.ToggleNikudAndTeamimSection -> handleToggleNikudAndTeamimSection()
            SearchAction.NikudAndTeamimSectionLongClicked -> handleNikudAndTeamimSectionLongClicked()

            // Dialogs / Help
            SearchAction.HideDialog -> handleHideDialog()
            is SearchAction.ShowHelpDialog -> handleShowHelpDialog(action.clickableTextData)
            is SearchAction.ToggleHelp -> handleToggleHelp(action)
            is SearchAction.ExampleClicked -> handleExampleClicked(action)

            // AI
            SearchAction.AiSearchClicked -> handleAiSearchClicked()
            SearchAction.ShowAiSearchDialog -> handleShowAiSearchDialog()
            is SearchAction.AiPrompt -> handleAiPrompt(aiPrompt = action)

            // TODO: misc: should be sorted
            is SearchAction.SearchSuggestionAccepted -> {
                handleSearchSuggestionAccepted(action)
            }
        }

    private var appliedInitialText: String? = null

    private fun handleInitialize(
        action: SearchAction.Initialize,
    ): SearchState {
        val text = action.initialText
        if (text.isEmpty()) return currentState
        // A rotation runs this again: what the user changed since then stays.
        if (text == appliedInitialText) return currentState
        appliedInitialText = text

        // A link, or another screen, filled the field.
        pendingSearchSource = SearchSource.DEEP_LINK
        loadAutocomplete(text)

        return currentState.copy(
            textFieldValue = TextFieldValue(
                text = text,
                selection = TextRange(text.length),
            ),
        )
    }

    // ---- Popular searches ("most searched" dialog) ---------------------------------------------

    private var popularSearchesFilter = PopularSearchesFilter.ALL_TIME

    private fun handlePopularSearchesClicked(): SearchState {
        analyticsProvider.logEvent(event = "SearchPopularSearchesOpened", params = mapOf("From" to "menu"))
        loadPopularSearches(popularSearchesFilter)
        return currentState
    }

    private fun handleMoreSuggestionsClicked(
        action: SearchAction.MoreSuggestionsClicked,
    ): SearchState {
        analyticsProvider.logEvent(
            event = "SearchPopularSearchesOpened",
            params = mapOf("From" to "more_row", "Filter" to action.filter.name),
        )
        popularSearchesFilter = action.filter
        loadPopularSearches(action.filter)
        return currentState
    }

    private fun loadPopularSearches(filter: PopularSearchesFilter) {
        launchEffect {
            dispatch(SearchAction.PopularSearchesLoaded(getAutocompleteSuggestionsUseCase.topList(filter)))
        }
    }

    private fun handlePopularSearchesLoaded(
        action: SearchAction.PopularSearchesLoaded,
    ): SearchState =
        currentState.copy(
            dialogState = SearchState.DialogState.PopularSearches(
                filter = action.list.filter,
                entries = action.list.entries.toImmutableList(),
                recentDays = action.list.recentDays,
            ),
        )

    private fun handlePopularSearchesFilterChanged(
        action: SearchAction.PopularSearchesFilterChanged,
    ): SearchState {
        analyticsProvider.logEvent(event = "SearchPopularSearchesFilterChanged", params = mapOf("Filter" to action.filter.name))
        popularSearchesFilter = action.filter
        loadPopularSearches(action.filter)
        return currentState
    }

    // A tap runs the search, like a history row; the source tells it apart from typing.
    private fun handlePopularSearchClicked(
        action: SearchAction.PopularSearchClicked,
    ): SearchState {
        val query = action.suggestion.query
        logPopularSearchClicked(query, filter = popularSearchesFilter, isFill = false)
        pendingSearchSource = SearchSource.TOP_LIST

        launchEffect {
            dispatch(SearchAction.SearchClicked)
        }

        return currentState.copy(
            textFieldValue = TextFieldValue(text = query, selection = TextRange(query.length)),
            errorMessage = null,
            autocomplete = AutocompleteUiState.Hidden,
            dialogState = SearchState.DialogState.None,
        )
    }

    // A long press only puts the expression in the field, to edit it before searching.
    private fun handlePopularSearchLongClicked(
        action: SearchAction.PopularSearchLongClicked,
    ): SearchState {
        val query = action.suggestion.query
        logPopularSearchClicked(query, filter = popularSearchesFilter, isFill = true)
        pendingSearchSource = SearchSource.TOP_LIST
        loadAutocomplete(query)

        launchEffect {
            sideEffectFlow.emit(SearchEffect.ShowKeyboard)
        }

        return currentState.copy(
            textFieldValue = TextFieldValue(text = query, selection = TextRange(query.length)),
            errorMessage = null,
            dialogState = SearchState.DialogState.None,
            suggestionsPage = SuggestionsPage.RESULTS,
        )
    }

    // ---- Autocomplete --------------------------------------------------------------------------

    private fun loadAutocomplete(text: String) {
        if (!currentState.isSearchSuggestionsEnabled) return

        if (text.isEmpty()) {
            updateState { it.copy(autocomplete = AutocompleteUiState.Hidden) }
            return
        }

        launchEffect {
            val suggestions = getAutocompleteSuggestionsUseCase.forPrefix(text)
            dispatch(SearchAction.AutocompleteLoaded(prefix = text, suggestions = suggestions.toImmutableList()))
        }
    }

    private fun loadPopularLists() {
        if (!currentState.isSearchSuggestionsEnabled) return

        launchEffect {
            val lists = getAutocompleteSuggestionsUseCase.popularLists() ?: return@launchEffect
            dispatch(SearchAction.PopularListsLoaded(lists))
        }
    }

    private fun handlePopularListsLoaded(
        action: SearchAction.PopularListsLoaded,
    ): SearchState =
        currentState.copy(popularLists = action.lists)

    // The pager reports every settled page, including the ones the store switched to itself
    // (a search, typing); only a page the user picked differs from the state at this point.
    private fun handleSuggestionsPageSelected(
        action: SearchAction.SuggestionsPageSelected,
    ): SearchState {
        if (action.page != currentState.suggestionsPage) {
            analyticsProvider.logEvent(event = "SearchSuggestionsPageSelected", params = mapOf("Page" to action.page.name))
        }

        return currentState.copy(suggestionsPage = action.page)
    }

    private fun logSuggestionClicked(
        suggestion: AutocompleteSuggestion,
        page: SuggestionsPage,
        isFill: Boolean,
    ) {
        analyticsProvider.logEvent(
            event = "SearchSuggestionClicked",
            params = mapOf(
                "Expression" to suggestion.query,
                "Page" to page.name,
                "Origin" to suggestion.origin.name,
                "Action" to if (isFill) "fill" else "search",
            ),
        )
    }

    private fun logPopularSearchClicked(
        query: String,
        filter: PopularSearchesFilter,
        isFill: Boolean,
    ) {
        analyticsProvider.logEvent(
            event = "SearchPopularSearchClicked",
            params = mapOf(
                "Expression" to query,
                "Filter" to filter.name,
                "Action" to if (isFill) "fill" else "search",
            ),
        )
    }

    // Results of a lookup that no longer matches the field (the user kept typing) are dropped.
    private fun handleAutocompleteLoaded(
        action: SearchAction.AutocompleteLoaded,
    ): SearchState {
        if (action.prefix != currentState.query || currentState.isSearching) return currentState

        return currentState.copy(
            autocomplete = AutocompleteUiState.ForPrefix(prefix = action.prefix, suggestions = action.suggestions),
        )
    }

    // Tapping a row runs it, like a history row.
    private fun handleAutocompleteSuggestionClicked(
        action: SearchAction.AutocompleteSuggestionClicked,
    ): SearchState {
        val query = action.suggestion.query
        logSuggestionClicked(action.suggestion, action.page, isFill = false)
        pendingSearchSource = SearchSource.SUGGESTION

        launchEffect {
            dispatch(SearchAction.SearchClicked)
        }

        return currentState.copy(
            textFieldValue = TextFieldValue(text = query, selection = TextRange(query.length)),
            errorMessage = null,
            autocomplete = AutocompleteUiState.Hidden,
        )
    }

    // The arrow only puts the expression in the field, to edit it before searching.
    private fun handleAutocompleteSuggestionFillClicked(
        action: SearchAction.AutocompleteSuggestionFillClicked,
    ): SearchState {
        val query = action.suggestion.query
        logSuggestionClicked(action.suggestion, action.page, isFill = true)
        pendingSearchSource = SearchSource.SUGGESTION
        loadAutocomplete(query)

        launchEffect {
            sideEffectFlow.emit(SearchEffect.ShowKeyboard)
        }

        return currentState.copy(
            textFieldValue = TextFieldValue(text = query, selection = TextRange(query.length)),
            errorMessage = null,
            suggestionsPage = SuggestionsPage.RESULTS,
        )
    }

    private fun handleSearchSuggestionAccepted(
        action: SearchAction.SearchSuggestionAccepted,
    ): SearchState {
        val expression = action.suggestedExpression

        launchEffect {
            dispatch(SearchAction.SearchClicked)
        }

        return currentState.copy(
            textFieldValue = currentState.textFieldValue.copy(
                text = expression,
                selection = TextRange(expression.length),
            ),
            errorMessage = null,
        )
    }

    private fun handleTextFieldValueChanged(
        action: SearchAction.TextFieldValueChanged,
    ): SearchState {
        // Only an edit counts; a cursor move, or the field echoing a value we set, keeps the source.
        val textChanged = action.textFieldValue.text != currentState.query
        if (textChanged) {
            pendingSearchSource = null
            loadAutocomplete(action.textFieldValue.text)
        }

        return currentState.copy(
            textFieldValue = action.textFieldValue,
            errorMessage = null,
            suggestionsPage = if (textChanged && action.textFieldValue.text.isNotEmpty()) SuggestionsPage.RESULTS else currentState.suggestionsPage,
        )
    }

    private fun handleAiPrompt(
        aiPrompt: SearchAction.AiPrompt,
    ): SearchState {
        return when (aiPrompt) {
            is SearchAction.AiPrompt.Submit -> {
                handleSubmitAiPrompt(text = aiPrompt.text)
            }

            is SearchAction.AiPrompt.Succeeded -> {
                handleAiPromptSucceeded(suggestion = aiPrompt.suggestion)
            }

            is SearchAction.AiPrompt.Failed -> {
                handleAiPromptFailed(message = aiPrompt.message)
            }
        }
    }

    private fun handleSubmitAiPrompt(text: String): SearchState {
        val trimmedText = text.trim()
        if (trimmedText.isEmpty()) {
            return currentState
        }

        settings.putString(key = Constants.PREF_AI_SEARCH_PROMPT, value = trimmedText)

        launchEffect {
            searchUseCaseProvider.getAiSearchSuggestionUseCase(prompt = trimmedText)
                .onSuccess { suggestion ->
                    dispatch(
                        SearchAction.AiPrompt.Succeeded(
                            suggestion = suggestion,
                        ),
                    )
                }
                .onFailure { throwable ->
                    dispatch(
                        SearchAction.AiPrompt.Failed(
                            message = throwable.message.orEmpty(),
                        ),
                    )
                }
        }

        return currentState.copy(
            dialogState = SearchState.DialogState.AiSearch(
                isLoading = true,
                lastPrompt = trimmedText,
            ),
        )
    }

    private fun handleAiPromptSucceeded(
        suggestion: AiSearchSuggestion,
    ): SearchState {
        val expression = suggestion.expression
        pendingSearchSource = SearchSource.AI
        loadAutocomplete(expression)

        return currentState.copy(
            textFieldValue = currentState.textFieldValue.copy(
                text = expression,
                selection = TextRange(expression.length),
            ),
            errorMessage = null,
            dialogState = SearchState.DialogState.None,
        )
    }

    private fun handleAiPromptFailed(
        message: String,
    ): SearchState {
        launchEffect {
            sideEffectFlow.emit(
                SearchEffect.ShowRawMessage(
                    message = message.ifBlank {
                        "לא הצלחנו ליצור חיפוש חכם"
                    },
                ),
            )
        }

        return currentState.copy(
            dialogState = SearchState.DialogState.AiSearch(
                isLoading = false,
                lastPrompt = getAiSearchLastPrompt(),
            ),
        )
    }

    private fun handleShowAiSearchDialog(): SearchState {
        return currentState.copy(
            dialogState = SearchState.DialogState.AiSearch(
                isLoading = false,
                lastPrompt = getAiSearchLastPrompt(),
            )
        )
    }

    private fun getAiSearchLastPrompt(): String =
        settings.getString(key = Constants.PREF_AI_SEARCH_PROMPT, defaultValue = "")

    private fun handleInterestingFactClicked(
        searchFact: SearchFact,
    ): SearchState {
        val title = searchFact.stringDesc
        val searchedChapters = searchUseCaseProvider.getSearchedChaptersUseCase(searchPlace = currentState.searchPlace)
        val generation = searchGeneration.incrementAndGet()

        launchEffect {
            var progress = 0

            val result = searchUseCaseProvider.executeSpecialSearchUseCase(
                searchedChapters = searchedChapters,
                searchType = searchFact.searchProvider(),
                shouldShowAsList = searchFact.shouldShowAsList,
                shouldKeepRunning = {
                    immediateKeepRunning.value && generation == searchGeneration.value
                },
                onProgress = { book, chapter ->
                    progress++

                    dispatch(
                        SearchAction.SearchProgressChanged.Special(
                            title = title,
                            titleExtraData = searchFact.extraData?.desc(),
                            book = book,
                            chapter = chapter,
                            progress = progress,
                            totalChapters = searchedChapters.size,
                        )
                    )
                },
            )

            if (result.wasInterrupted && result.latestPlace != null) {
                sideEffectFlow.emit(
                    SearchEffect.ShowMessage(
                        message = result.latestPlace!!,
                    ),
                )
            }

            when (result) {
                is SpecialSearchResult.Items -> {
                    dispatch(
                        SearchAction.SearchResultsFound(
                            results = result.results,
                            generation = generation,
                        ),
                    )

                    dispatch(
                        SearchAction.SearchCompleted(
                            regex = "",
                            resultsCount = result.results.size,
                            differentVersesCount = result.results.countDifferentVerses(),
                            generation = generation,
                        ),
                    )
                }

                is SpecialSearchResult.Summary -> {
                    dispatch(
                        SearchAction.SearchCompleted(
                            regex = "",
                            resultsCount = 0,
                            differentVersesCount = 0,
                            generation = generation,
                            summaryDialog = SearchState.DialogState.General(
                                title = title,
                                message = result.message,
                            ),
                        ),
                    )
                }
            }

            sideEffectFlow.emit(
                SearchEffect.Vibrate(
                    milliseconds = 100,
                ),
            )
        }

        immediateKeepRunning.value = true
        return currentState.copy(
            isLoading = true,
            isSearching = true,
            keepRunning = true,
            results = persistentListOf(),
            errorMessage = null,
            resultsSummary = SharedRes.strings.search_results.desc(),
            dialogState = SearchState.DialogState.ExecutingLocalSearch(
                title = title,
                titleExtraData = searchFact.extraData?.desc(),
                message = SharedRes.strings.search_progress_special_search_format.format(
                    "",
                    "",
                ),
                totalChapters = searchedChapters.size,
                progress = 0,
                showNativeAd = currentState.searchPlace == SearchPlace.WHOLE_BIBLE && shouldShowAdsUseCase(),
            ),
        )
    }

    private fun handleSearchProgressChanged(
        action: SearchAction.SearchProgressChanged,
    ): SearchState =
        when (action) {
            is SearchAction.SearchProgressChanged.Regular -> {
                handleRegularSearchProgressChanged(action)
            }

            is SearchAction.SearchProgressChanged.Special -> {
                handleSpecialSearchProgressChanged(action)
            }
        }

    private fun handleRegularSearchProgressChanged(
        action: SearchAction.SearchProgressChanged.Regular,
    ): SearchState {
        if (!currentState.keepRunning) {
            return currentState
        }
        return currentState.copy(
            dialogState = SearchState.DialogState.ExecutingLocalSearch(
                title = SharedRes.strings.expression_to_be_searched_format.format(
                    currentState.query,
                ),
                message = SharedRes.strings.search_progress_format.format(
                    action.book,
                    action.chapter.addGershaim(),
                    action.resultsCount.formatWithCommas(),
                ),
                totalChapters = action.totalChapters,
                progress = action.progress,
                showNativeAd = currentState.searchPlace == SearchPlace.WHOLE_BIBLE && shouldShowAdsUseCase(),
            ),
        )
    }

    private fun handleSpecialSearchProgressChanged(
        action: SearchAction.SearchProgressChanged.Special,
    ): SearchState {
        if (!currentState.keepRunning) {
            return currentState
        }
        return currentState.copy(
            dialogState = SearchState.DialogState.ExecutingLocalSearch(
                title = action.title,
                titleExtraData = action.titleExtraData,
                message = SharedRes.strings.search_progress_special_search_format.format(
                    action.book,
                    action.chapter.addGershaim(),
                ),
                totalChapters = action.totalChapters,
                progress = action.progress,
                showNativeAd = currentState.searchPlace == SearchPlace.WHOLE_BIBLE && shouldShowAdsUseCase(),
            ),
        )
    }

    private fun handleAiSearchClicked(): SearchState {
        return currentState.copy(
            dialogState = SearchState.DialogState.AiSearch(
                isLoading = false,
                lastPrompt = getAiSearchLastPrompt(),
            )
        )
    }

    private fun handleClearLongClicked(): SearchState =
        onlyEffect(
            SearchEffect.ShowMessage(
                message = SharedRes.strings.clear_text.desc(),
            ),
        )

    private fun handleHorizontalArrowClicked(
        action: SearchAction.HorizontalArrowClicked,
    ): SearchState {
        val current = currentState.textFieldValue
        val currentCursor = current.selection.start.coerceIn(
            minimumValue = 0,
            maximumValue = current.text.length,
        )

        val newCursor = when (action.direction) {
            HorizontalDirection.RIGHT -> {
                currentCursor - 1
            }

            HorizontalDirection.LEFT -> {
                currentCursor + 1
            }
        }.coerceIn(
            minimumValue = 0,
            maximumValue = current.text.length,
        )

        return currentState.copy(
            textFieldValue = current.copy(
                selection = TextRange(newCursor),
            ),
        )
    }

    private fun handleHorizontalArrowLongClicked(
        action: SearchAction.HorizontalArrowLongClicked,
    ): SearchState {
        val current = currentState.textFieldValue

        val newCursor = when (action.direction) {
            HorizontalDirection.RIGHT -> 0
            HorizontalDirection.LEFT -> current.text.length
        }

        return currentState.copy(
            textFieldValue = current.copy(
                selection = TextRange(newCursor),
            ),
        )
    }

    private fun handleNikudAndTeamimSectionLongClicked(): SearchState =
        onlyEffect(
            SearchEffect.ShowRawMessage(
                message = "הצגה/הסתרה של סימני ניקוד וטעמים",
            ),
        )

    private fun handleToggleNikudAndTeamimSection(): SearchState =
        currentState.copy(
            isNikudAndTeamimSectionVisible = !currentState.isNikudAndTeamimSectionVisible,
        )

    private fun handleSignClicked(
        action: SearchAction.SignClicked,
    ): SearchState {
        val current = currentState.textFieldValue
        val selection = current.selection
        val start = selection.min
        val end = selection.max

        val newText = current.text.replaceRange(
            startIndex = start,
            endIndex = end,
            replacement = action.sign,
        )

        val newCursor = start + action.sign.length

        pendingSearchSource = null
        loadAutocomplete(newText)

        return currentState.copy(
            textFieldValue = current.copy(
                text = newText,
                selection = TextRange(newCursor),
            ),
            errorMessage = null,
        )
    }

    private fun handleSignLongClicked(
        action: SearchAction.SignLongClicked,
    ): SearchState =
        onlyEffect(
            SearchEffect.ShowRawMessage(
                message = action.sign,
            ),
        )


    private fun handleShowHelpDialog(clickableTextData: ClickableTextData): SearchState {
        return currentState.copy(
            dialogState = SearchState.DialogState.Help(
                helpDialogClickableTextData = clickableTextData,
                isDontShowAgainChecked = currentState.isSkipReadMeChecked,
            )
        )
    }

    private fun handleSearchClicked(): SearchState {
        val rawSearchedText = currentState.query
        val searchedTextForEmptyCheck = rawSearchedText.trim()

        analyticsProvider.logEvent(
            event = "SearchClicked",
            params = mapOf(
                "Expression" to rawSearchedText,
                "SearchMode" to currentState.searchMode,
                "searchPlace" to currentState.searchPlace,
            ),
        )

        if (searchedTextForEmptyCheck.isEmpty()) {
            return handleEmptySearchClicked()
        }

        searchUseCaseProvider.increaseNumberOfSearchesUseCase()

        val prepareResult = searchUseCaseProvider.prepareLocalSearchRequestUseCase(
            PrepareLocalSearchRequestInput(
                searchedText = rawSearchedText, // שומר רווח סוף בשביל WORD_BOUNDARY
                searchMode = currentState.searchMode,
                isDebugUser = currentState.isDebugUser,
            ),
        )

        recordSearchHistory(prepareResult)
        searchHistoryHint.onSearchClicked(startsSearch = prepareResult.startsSearch())

        val nextState = handlePrepareLocalSearchRequestResult(
            searchedText = rawSearchedText,
            prepareResult = prepareResult,
        )

        if (!prepareResult.startsSearch()) return nextState

        runningSearchSource = pendingSearchSource ?: SearchSource.TYPED
        pendingSearchSource = null

        return nextState.copy(autocomplete = AutocompleteUiState.Hidden, suggestionsPage = SuggestionsPage.RESULTS)
    }

    private fun handleEmptySearchClicked(): SearchState =
        onlyEffect(
            SearchEffect.ShowRawMessage("תיבת החיפוש ריקה"),
        )

    private fun handlePrepareLocalSearchRequestResult(
        searchedText: String,
        prepareResult: PrepareLocalSearchRequestResult,
    ): SearchState =
        when (prepareResult) {
            is PrepareLocalSearchRequestResult.Ready -> {
                handleReadyLocalSearch(
                    searchedText = searchedText,
                    prepareResult = prepareResult,
                )
            }

            is PrepareLocalSearchRequestResult.Error -> {
                currentState.copy(
                    errorMessage = prepareResult.message,
                )
            }

            is PrepareLocalSearchRequestResult.SuggestAlternative -> {
                handleSearchSuggestionFound(
                    SearchAction.SearchSuggestionFound(
                        searchSuggestion = prepareResult.searchSuggestion,
                    ),
                )
            }

            is PrepareLocalSearchRequestResult.DebugMessage -> {
                onlyEffect(
                    SearchEffect.ShowRawMessage(
                        message = prepareResult.message,
                    ),
                )
            }

            is PrepareLocalSearchRequestResult.ExecuteSpecial -> {
                handleExecuteSpecialSearch(
                    searchNumberOrRoot = prepareResult.searchNumberOrRoot,
                    regex = prepareResult.regex,
                    dateQuery = prepareResult.dateQuery,
                )
            }

            PrepareLocalSearchRequestResult.ToggleDebugUser -> {
                currentState.copy(
                    isDebugUser = !currentState.isDebugUser,
                )
            }
        }

    private fun handleExecuteSpecialSearch(
        searchNumberOrRoot: SearchNumberOrRoot,
        regex: String,
        dateQuery: DateQuery?,
    ): SearchState {
        // Supersede any in-flight regular/special run so its stale results can't append here.
        searchGeneration.incrementAndGet()

        launchEffect {
            sideEffectFlow.emit(SearchEffect.HideKeyboard)
        }

        val searchQuery = searchUseCaseProvider.extractSpecialSearchQueryUseCase(
            searchNumberOrRoot = searchNumberOrRoot,
            regex = regex,
        )

        // for a date, show how the query was understood: "י׳ בתשרי (החודש השביעי)"
        val sentence = searchNumberOrRoot.stringRes.format(dateQuery?.label ?: searchQuery)

        searchStartTimeMark = TimeSource.Monotonic.markNow()

        launchEffect {
            when (searchNumberOrRoot) {
                SearchNumberOrRoot.NUMBER -> {
                    executeNumberSearch(searchQuery)
                }

                SearchNumberOrRoot.ROOT -> {
                    executeRootSearch(searchQuery)
                }

                SearchNumberOrRoot.DATE -> {
                    executeDateSearch(
                        searchQuery = searchQuery,
                        dateQuery = requireNotNull(dateQuery) { "DATE search without a parsed date" },
                    )
                }
            }
        }

        immediateKeepRunning.value = true
        return currentState.copy(
            isSearching = true,
            keepRunning = true,
            results = persistentListOf(),
            errorMessage = null,
            regex = regex,
            searchedData = searchQuery,
            dialogState = SearchState.DialogState.ExecutingRemoteSearch(
                sentence = sentence,
            ),
        )
    }

    private suspend fun executeNumberSearch(
        searchQuery: String,
    ) {
        searchUseCaseProvider.searchNumberUseCase(
            searchQuery = searchQuery,
            onError = { pair ->
                dispatch(
                    SearchAction.SearchFailed(
                        message = pair.first,
                    ),
                )
            },
        ).onSearchCompletion { results ->
            trackSpecialSearchAnalytics(
                query = searchQuery,
                mode = SearchNumberOrRoot.NUMBER,
                resultsCount = results?.size ?: 0,
            )
        }.onSuccess { results ->
            updateState { state ->
                state.copy(
                    isSearching = false,
                    results = results,
                    resultsSummary = SharedRes.strings.search_results_placeholder.format(
                        results.size,
                    ),
                    dialogState = SearchState.DialogState.None,
                    errorMessage = null,
                )
            }
        }.onFailure { throwable ->
            handleRemoteSearchFailure(throwable)
        }
    }

    private suspend fun executeRootSearch(
        searchQuery: String,
    ) {
        searchUseCaseProvider.searchRootUseCase(
            searchQuery = searchQuery,
            onlyQri = currentState.onlyQri,
            onError = { pair ->
                dispatch(
                    SearchAction.SearchFailed(
                        message = pair.first,
                    ),
                )
            },
        ).onSearchCompletion { data ->
            trackSpecialSearchAnalytics(
                query = searchQuery,
                mode = SearchNumberOrRoot.ROOT,
                resultsCount = data?.results?.size ?: 0,
            )
        }.onSuccess { data ->
            updateState { state ->
                state.copy(
                    isSearching = false,
                    results = data.results,
                    resultsSummary = data.report,
                    dialogState = SearchState.DialogState.None,
                    errorMessage = null,
                )
            }
        }.onFailure { throwable ->
            handleRemoteSearchFailure(throwable)
        }
    }

    private suspend fun executeDateSearch(
        searchQuery: String,
        dateQuery: DateQuery,
    ) {
        searchUseCaseProvider.searchDateUseCase(
            dateQuery = dateQuery,
            onError = { pair ->
                dispatch(
                    SearchAction.SearchFailed(
                        message = pair.first,
                    ),
                )
            },
        ).onSearchCompletion { data ->
            trackSpecialSearchAnalytics(
                query = searchQuery,
                mode = SearchNumberOrRoot.DATE,
                resultsCount = data?.results?.size ?: 0,
            )
        }.onSuccess { data ->
            updateState { state ->
                state.copy(
                    isSearching = false,
                    results = data.results,
                    resultsSummary = data.report,
                    dialogState = SearchState.DialogState.None,
                    errorMessage = null,
                )
            }
        }.onFailure { throwable ->
            handleRemoteSearchFailure(throwable)
        }
    }

    private fun trackSpecialSearchAnalytics(
        query: String,
        mode: SearchNumberOrRoot,
        resultsCount: Int,
    ) {
        trackSearchAnalytics(
            query = query,
            searchMode = mode.name,
            searchPlace = currentState.searchPlace.name,
            withNikud = currentState.withNikud,
            withTeamim = currentState.withTeamim,
            onlyQri = currentState.onlyQri,
            resultsCount = resultsCount,
            durationMs = durationMs,
            cancelledByUser = false,
        )
    }

    private fun handleRemoteSearchFailure(
        throwable: Throwable,
    ) {
        updateState { state ->
            state.copy(
                isSearching = false,
                dialogState = SearchState.DialogState.None,
                errorMessage = (throwable.message ?: "אירעה שגיאה בחיפוש").desc(),
            )
        }
    }

    private fun handleReadyLocalSearch(
        searchedText: String,
        prepareResult: PrepareLocalSearchRequestResult.Ready,
    ): SearchState {
        prepareResult.suggestions.forEach { suggestion ->
            dispatch(SearchAction.SearchSuggestionFound(suggestion))
        }

        val searchedChapters = searchUseCaseProvider.getSearchedChaptersUseCase(currentState.searchPlace)

        searchStartTimeMark = TimeSource.Monotonic.markNow()

        executeRegularSearch(
            originalExpression = prepareResult.originalExpression,
            regex = prepareResult.normalizedRegex,
            searchedChapters = searchedChapters,
            generation = searchGeneration.incrementAndGet(),
        )

        immediateKeepRunning.value = true
        return currentState.copy(
            isSearching = true,
            keepRunning = true,
            results = persistentListOf(),
            errorMessage = null,
            regex = prepareResult.normalizedRegex,
            resultsSummary = SharedRes.strings.search_results.desc(),
            dialogState = buildInitialExecutingLocalSearchDialogState(
                searchedText = searchedText,
                totalChapters = searchedChapters.size,
            ),
        )
    }

    private fun buildInitialExecutingLocalSearchDialogState(
        searchedText: String,
        totalChapters: Int,
    ): SearchState.DialogState.ExecutingLocalSearch =
        SearchState.DialogState.ExecutingLocalSearch(
            title = SharedRes.strings.expression_to_be_searched_format.format(
                searchedText,
            ),
            message = SharedRes.strings.search_progress_format.format(
                "",
                "",
                0,
            ),
            totalChapters = totalChapters,
            progress = 0,
            showNativeAd = currentState.searchPlace == SearchPlace.WHOLE_BIBLE && shouldShowAdsUseCase(),
        )

    private fun handleToolbarClicked(
        action: SearchAction.ToolbarClicked,
    ): SearchState {
        return when (val toolbarAction = action.toolbarAction) {
            SearchToolbarAction.Help -> {
                handleHelpClicked()
            }

            SearchToolbarAction.History -> {
                handleHistoryClicked()
            }

            SearchToolbarAction.PopularSearches -> {
                handlePopularSearchesClicked()
            }

            SearchToolbarAction.SelectAll -> {
                handleSelectAll()
            }

            SearchToolbarAction.Copy -> {
                handleCopy()
            }

            SearchToolbarAction.Paste -> {
                handlePaste()
            }

            SearchToolbarAction.Export -> {
                handleExport()
            }

            SearchToolbarAction.ShareSearch -> {
                handleShareSearch()
            }

            SearchToolbarAction.Stats -> {
                handleFactsMenuClicked()
            }

            SearchToolbarAction.CopyAllResults -> {
                handleCopyAllResults()
            }

            is SearchToolbarAction.SearchMode -> {
                handleSearchModeToolbarClicked(toolbarAction)
            }

            is SearchToolbarAction.WhereToSearch -> {
                handleWhereToSearchToolbarClicked(toolbarAction)
            }

            is SearchToolbarAction.TextOnlyQri -> {
                handleTextOnlyQri(toolbarAction)
            }

            is SearchToolbarAction.TextWithNikud -> {
                handleTextWithNikud(toolbarAction)
            }

            is SearchToolbarAction.TextWithTeamim -> {
                handleTextWithTeamim(toolbarAction)
            }
        }
    }

    private fun recordSearchHistory(
        prepareResult: PrepareLocalSearchRequestResult,
    ) {
        val state = currentState

        launchEffect {
            recordSearchHistoryUseCase(state = state, prepareResult = prepareResult)
        }
    }

    private fun handleHistoryClicked(): SearchState {
        searchHistoryHint.onHistoryOpened()
        loadHistory(openDialog = true)
        return currentState
    }

    // openDialog = false refreshes an already open history dialog and never reopens a closed one.
    private fun loadHistory(
        openDialog: Boolean = false,
        change: suspend () -> Unit = {},
    ) {
        val sort = historySort

        launchEffect {
            change()

            val entries = searchHistoryRepository.getHistory(sort).toImmutableList()

            dispatch(
                SearchAction.HistoryLoaded(
                    entries = entries,
                    sort = sort,
                    openDialog = openDialog,
                ),
            )
        }
    }

    private fun handleHistoryLoaded(
        action: SearchAction.HistoryLoaded,
    ): SearchState {
        val openDialog = currentState.dialogState as? SearchState.DialogState.History

        if (openDialog == null && !action.openDialog) return currentState

        return currentState.copy(
            dialogState = SearchState.DialogState.History(
                entries = action.entries,
                sort = action.sort,
                isConfirmingClear = openDialog?.isConfirmingClear ?: false,
            ),
        )
    }

    private fun handleHistorySortChanged(
        action: SearchAction.HistorySortChanged,
    ): SearchState {
        historySort = action.sort
        loadHistory()
        return currentState
    }

    private fun handleHistoryEntryDeleteClicked(
        action: SearchAction.HistoryEntryDeleteClicked,
    ): SearchState {
        loadHistory {
            searchHistoryRepository.delete(action.entry.key)
        }
        return currentState
    }

    private fun handleClearHistoryConfirmation(
        isConfirming: Boolean,
    ): SearchState {
        val dialog = currentState.dialogState as? SearchState.DialogState.History
            ?: return currentState

        return currentState.copy(
            dialogState = dialog.copy(isConfirmingClear = isConfirming),
        )
    }

    private fun handleClearHistoryConfirmed(): SearchState {
        loadHistory {
            searchHistoryRepository.clear()
        }
        return handleClearHistoryConfirmation(isConfirming = false)
    }

    // Restores the entry's own options and runs it. The mikud is not part of an entry, so a
    // by-mikud entry searches whatever the mikud is now.
    private fun handleHistoryEntryClicked(
        action: SearchAction.HistoryEntryClicked,
    ): SearchState {
        val key = action.entry.key

        if (key.kind == SearchHistoryKind.REGULAR) {
            settings.putString(
                key = Constants.PREF_SEARCH_MODE,
                value = key.searchMode.name,
            )
        }

        pendingSearchSource = SearchSource.HISTORY

        launchEffect {
            dispatch(SearchAction.SearchClicked)
        }

        return currentState.restoredFrom(key)
    }

    private fun handleSelectAll(): SearchState {
        val text = currentState.textFieldValue.text

        return currentState.copy(
            textFieldValue = currentState.textFieldValue.copy(
                selection = TextRange(
                    start = 0,
                    end = text.length,
                ),
            ),
        )
    }

    private fun handleCopy(): SearchState {
        val textToCopy = searchUseCaseProvider.getTextToCopyFromTextFieldUseCase(
            current = currentState.textFieldValue,
        )

        if (textToCopy.isBlank()) {
            return onlyEffect(
                SearchEffect.ShowRawMessage("אין מה להעתיק"),
            )
        }

        return onlyEffect(
            SearchEffect.CopyToClipboard(textToCopy),
        )
    }

    private fun handlePaste(): SearchState {
        // null = this platform (web) can only read the clipboard asynchronously.
        val text = myClipboardManager.getText() ?: return handlePasteAsync()

        val updated = searchUseCaseProvider.insertTextAtCursorUseCase(
            current = currentState.textFieldValue,
            textToInsert = text,
        )

        pendingSearchSource = null
        loadAutocomplete(updated.text)

        return currentState.copy(
            textFieldValue = updated,
        )
    }

    private fun handlePasteAsync(): SearchState {
        launchEffect {
            val text = myClipboardManager.readText().orEmpty()
            if (text.isEmpty()) return@launchEffect

            updateState { state ->
                state.copy(
                    textFieldValue = searchUseCaseProvider.insertTextAtCursorUseCase(
                        current = state.textFieldValue,
                        textToInsert = text,
                    ),
                )
            }

            pendingSearchSource = null
            loadAutocomplete(currentState.query)
        }
        return currentState
    }

    private fun handleSaveFile(content: String): SearchState {
        launchEffect {
            withContext(IoDispatcher) {
                val success = searchUseCaseProvider.saveSearchResultsToFileUseCase(
                    searchResultsText = currentState.resultsSummary,
                    searchMode = currentState.searchMode.stringResource.desc(),
                    content = content,
                )

                sideEffectFlow.emit(
                    SearchEffect.ShowMessage(
                        if (success) {
                            SharedRes.strings.file_saved_successfully
                        } else {
                            SharedRes.strings.file_was_not_saved
                        }.desc()
                    )
                )

            }
        }

        return currentState
    }

    private fun handleSearchResultsCopyOptions(
        title: StringDesc,
        operation: CopyOptionsOperation,
    ): SearchState {
        if (currentState.results.isEmpty()) {
            return onlyEffect(
                SearchEffect.ShowMessage(
                    message = SharedRes.strings.no_search_results.desc(),
                ),
            )
        }

        return currentState.copy(
            dialogState = SearchState.DialogState.CopyOptionsDialog(
                title = title,
                input = CopyOptionsInput.SearchResultsV2(
                    originalExpression = currentState.query,
                    items = currentState.results,
                ),
                config = buildSearchResultsCopyOptionsConfig(),
                operation = operation,
            ),
        )
    }

    private fun handleExport(): SearchState =
        handleSearchResultsCopyOptions(
            title = SharedRes.strings.exporting_to_file.desc(),
            operation = CopyOptionsOperation.SAVE_FILE,
        )

    private fun handleCopyAllResults(): SearchState =
        handleSearchResultsCopyOptions(
            title = SharedRes.strings.copy_search_result.desc(),
            operation = CopyOptionsOperation.COPY_TEXT,
        )

    private fun handleShareSearch(): SearchState {
        val text = currentState.query

        if (text.isBlank()) {
            return onlyEffect(
                SearchEffect.ShowRawMessage(
                    message = "אין ביטוי חיפוש לשיתוף",
                ),
            )
        }

        val link = DeepLinks.buildSearchLink(expression = text)

        analyticsProvider.logEvent(
            event = "Search",
            params = mapOf("DeepLink" to link),
        )

        launchEffect {
            sideEffectFlow.emit(
                SearchEffect.CopyToClipboard(
                    text = link,
                ),
            )

            sideEffectFlow.emit(
                SearchEffect.ShareSearch(
                    text = "$text\n$link",
                ),
            )
        }

        return currentState
    }

    private fun handleFactsMenuClicked(): SearchState {
        return currentState.copy(
            dialogState = SearchState.DialogState.InterestingFactsMenu(
                items = searchUseCaseProvider.getSearchFactsUseCase().toImmutableList(),
            )
        )
    }

    private fun buildSearchResultsCopyOptionsConfig(): CopyOptionsConfig =
        CopyOptionsConfig(
            shouldShowSearchedExpressionOption = true,
            shouldShowRemoveDuplicatesOption = true,
            shouldShowSortResultOption = true,
            shouldShowIncludeBookAndChapterOption = false,
            shouldShowHighlightsSection = true,
            shouldShowAdvancedOptionsSection = true,
        )

    private fun handleHelpClicked(): SearchState {
        launchEffect {
            dispatch(action = SearchAction.ShowHelpDialog(clickableTextData = getSearchHelpContent()))
        }
        return currentState
    }

    private fun getSearchHelpContent(): ClickableTextData {
        val clickableTextData = searchUseCaseProvider.linkToExamplesUseCase.getSearchHelpContent(
            onSearchExampleClicked = {
                dispatch(SearchAction.ExampleClicked(example = it))
            },
            debugFlag = debugInfo.isDebugMode,
        )
        return clickableTextData
    }

    private fun handleWhereToSearchToolbarClicked(
        toolbarAction: SearchToolbarAction.WhereToSearch,
    ): SearchState {
        val searchPlace = when (toolbarAction) {
            SearchToolbarAction.WhereToSearch.WholeBible -> {
                SearchPlace.WHOLE_BIBLE
            }

            SearchToolbarAction.WhereToSearch.ByMikud -> {
                SearchPlace.BY_MIKUD
            }
        }

        return currentState.copy(
            searchPlace = searchPlace,
        )
    }

    private fun handleTextOnlyQri(
        toolbarAction: SearchToolbarAction.TextOnlyQri,
    ): SearchState =
        currentState.copy(
            onlyQri = toolbarAction.checked,
        )

    private fun handleTextWithNikud(
        toolbarAction: SearchToolbarAction.TextWithNikud,
    ): SearchState =
        currentState.copy(
            withNikud = toolbarAction.checked,
        )

    private fun handleTextWithTeamim(
        toolbarAction: SearchToolbarAction.TextWithTeamim,
    ): SearchState =
        currentState.copy(
            withTeamim = toolbarAction.checked,
        )

    private fun handleSearchModeToolbarClicked(
        toolbarAction: SearchToolbarAction.SearchMode,
    ): SearchState {
        val searchMode = when (toolbarAction) {
            SearchToolbarAction.SearchMode.RegularSearch -> {
                SearchMode.REGULAR_SEARCH
            }

            SearchToolbarAction.SearchMode.PasukLeHazmana -> {
                SearchMode.VERSE_FOR_INVITATION
            }

            SearchToolbarAction.SearchMode.FirstLastLettersInName -> {
                SearchMode.FIRST_LAST_LETTERS_IN_NAME
            }
        }

        settings.putString(
            key = Constants.PREF_SEARCH_MODE,
            value = searchMode.name,
        )

        return currentState.copy(
            searchMode = searchMode,
        )
    }

    private fun handleToggleHelp(
        action: SearchAction.ToggleHelp,
    ): SearchState {
        settings.putBoolean(
            key = SKIP_READ_ME_PREF,
            value = action.shouldShowNextTime,
        )

        return currentState.copy(
            isSkipReadMeChecked = action.shouldShowNextTime,
            dialogState = SearchState.DialogState.None,
        )
    }

    private fun handleExampleClicked(
        action: SearchAction.ExampleClicked,
    ): SearchState {
        pendingSearchSource = SearchSource.GUIDE_EXAMPLE
        loadAutocomplete(action.example)

        return currentState.copy(
            textFieldValue = TextFieldValue(
                text = action.example,
                selection = TextRange(action.example.length),
            ),
            dialogState = SearchState.DialogState.None,
            suggestionsPage = SuggestionsPage.RESULTS,
        )
    }

    private fun handleClearClicked(): SearchState {
        launchEffect {
            sideEffectFlow.emit(SearchEffect.ShowKeyboard)
            sideEffectFlow.emit(SearchEffect.ScrollSignsContainerToStart)
        }

        pendingSearchSource = null

        return currentState.copy(
            autocomplete = AutocompleteUiState.Hidden,
            textFieldValue = TextFieldValue(),
            results = persistentListOf(),
            regex = "",
            errorMessage = null,
            resultsSummary = SharedRes.strings.search_results.desc(),
            keepRunning = true,
            dialogState = SearchState.DialogState.None,
        )
    }

    private fun handleStopSearching(): SearchState =
        currentState.copy(
            keepRunning = false,
            dialogState = SearchState.DialogState.None,
        )

    private fun handleSearchResultsFound(
        action: SearchAction.SearchResultsFound,
    ): SearchState {
        if (!currentState.keepRunning) {
            return currentState
        }
        // Drop results from a superseded run (e.g. a double-tapped search), then dedup by id as
        // a safety net so the results LazyColumn never receives two items with the same key.
        if (action.generation != searchGeneration.value) {
            return currentState
        }
        val updatedResults = (currentState.results + action.results)
            .distinctBy { it.id }
            .toImmutableList()

        return currentState.copy(
            results = updatedResults,
            resultsSummary = SharedRes.strings.search_summary_format.format(
                updatedResults.size.formatWithCommas(),
                updatedResults.countDifferentVerses().formatWithCommas(),
            ),
        )
    }

    private fun ImmutableList<VerseUiModel>.countDifferentVerses(): Int =
        distinctBy {
            Triple(
                it.bookIndex,
                it.chapterIndex,
                it.verse,
            )
        }.size

    private fun handleSearchCompleted(
        action: SearchAction.SearchCompleted,
    ): SearchState {
        val completion = completeSearch(
            state = currentState,
            action = action,
            currentGeneration = searchGeneration.value,
        ) ?: return currentState

        analyticsProvider.logEvent(
            event = "SearchCompleted",
            params = completion.analyticsParams,
        )

        val wasCancelled = !currentState.keepRunning
        if (action.resultsCount > 0 && !wasCancelled) {
            launchEffect { reviewPrompter.onDeferredSuccessMoment(moment = ReviewMoment.SEARCH) }
        }

        return completion.state
    }

    private fun handleSearchFailed(
        action: SearchAction.SearchFailed,
    ): SearchState =
        currentState.copy(
            isSearching = false,
            keepRunning = true,
            errorMessage = action.message,
            dialogState = SearchState.DialogState.None,
        )

    private fun handleSearchSuggestionFound(
        action: SearchAction.SearchSuggestionFound,
    ): SearchState {
        val suggestion = searchUseCaseProvider.buildSearchSuggestionUseCase(
            originalExpression = currentState.query,
            searchSuggestion = action.searchSuggestion,
            hebrewGender = currentState.hebrewGender,
        ) ?: return currentState

        return onlyEffect(
            SearchEffect.ShowSearchSuggestion(
                message = suggestion.message,
                suggestedExpression = suggestion.suggestedExpression,
            ),
        )
    }

    private fun handleResultClicked(
        action: SearchAction.ResultClicked,
    ): SearchState =
        buildChapterDialogState(
            item = action.item,
        )

    private fun buildChapterDialogState(
        item: VerseUiModel,
    ): SearchState {

        if (item.bookIndex < 0) {
            return currentState.copy(
                dialogState = SearchState.DialogState.None,
            )
        }

        val (onlyContent, markupRange) = searchUseCaseProvider.getHighlightedVerseMarkupRangeUseCase(
            bookIndex = item.bookIndex,
            chapter = item.chapterIndex.toOtiot(),
            otVerse = item.verse,
            onlyQri = currentState.onlyQri,
        )

        val spannedRangeList = buildList {
            addAll(
                searchUseCaseProvider.makeOtiotPasukSmallerUseCase(
                    charSequence = onlyContent,
                ),
            )

            add(
                SpannedRange(
                    spanType = SpanType.BackgroundColor(Color.Yellow),
                    textRange = markupRange,
                ),
            )
        }

        return currentState.copy(
            dialogState = SearchState.DialogState.FullChapter(
                chapterData = ChapterData(
                    bookIndex = item.bookIndex,
                    chapterIndex = item.chapterIndex,
                    content = onlyContent,
                    spannedRangeList = spannedRangeList.toImmutableList(),
                ),
            ),
        )
    }

    private fun handleShowNextChapter(): SearchState =
        searchUseCaseProvider.navigateToAdjacentChapterUseCase(
            chapterData = (currentState.dialogState as? SearchState.DialogState.FullChapter)?.chapterData,
            direction = ChapterDirection.Next
        ).let {
            currentState.copy(dialogState = SearchState.DialogState.FullChapter(chapterData = it))
        }

    private fun handleShowPreviousChapter(): SearchState =
        searchUseCaseProvider.navigateToAdjacentChapterUseCase(
            chapterData = (currentState.dialogState as? SearchState.DialogState.FullChapter)?.chapterData,
            direction = ChapterDirection.Previous
        ).let {
            currentState.copy(dialogState = SearchState.DialogState.FullChapter(chapterData = it))
        }

    private fun handleResultLongClicked(
        action: SearchAction.ResultLongClicked,
    ): SearchState =
        currentState.copy(
            dialogState = SearchState.DialogState.CopyOptionsDialog(
                title = SharedRes.strings.copy_options.desc(),
                input = CopyOptionsInput.SingleSearchResult(
                    item = action.item,
                ),
                config = buildSingleSearchResultCopyOptionsConfig(),
                operation = CopyOptionsOperation.COPY_TEXT,
            ),
        )

    private fun buildSingleSearchResultCopyOptionsConfig(): CopyOptionsConfig =
        CopyOptionsConfig(
            shouldShowSearchedExpressionOption = false,
            shouldShowRemoveDuplicatesOption = false,
            shouldShowSortResultOption = false,
            shouldShowIncludeBookAndChapterOption = false,
            shouldShowHighlightsSection = true,
            shouldShowAdvancedOptionsSection = true,
        )

    private fun handleSearchLongClicked(): SearchState =
        currentState.copy(
            dialogState = SearchState.DialogState.RegexInfo(
                regex = currentState.regex,
                resultsCount = currentState.results.size,
            ),
        )

    private fun handleResultsByBookClicked(): SearchState {
        val items = currentState.results.countResultsByBook()
        analyticsProvider.logEvent(
            event = "SearchResultsByBookOpened",
            params = mapOf(
                "Number of books" to items.size,
                "Number of results" to currentState.results.size,
            ),
        )
        return currentState.copy(
            dialogState = SearchState.DialogState.ResultsByBook(items = items),
        )
    }

    private fun handleResultsByBookItemClicked(
        action: SearchAction.ResultsByBookItemClicked,
    ): SearchState {
        val jump = currentState.results.jumpToFirstResultOf(action.bookIndex)
        analyticsProvider.logEvent(
            event = "SearchResultsByBookItemClicked",
            params = mapOf(
                "Book" to (bookNamesHebrew.getOrNull(action.bookIndex) ?: action.bookIndex),
                "Result index" to (jump?.index ?: -1),
            ),
        )
        return currentState.copy(
            dialogState = SearchState.DialogState.None,
            resultsJump = jump,
        )
    }

    private fun handleHideDialog(): SearchState =
        currentState.copy(
            dialogState = SearchState.DialogState.None,
        )

    private fun executeRegularSearch(
        originalExpression: String,
        regex: String,
        searchedChapters: List<SearchPlaceData>,
        generation: Int,
    ) {
        launchEffect {
            sideEffectFlow.emit(SearchEffect.HideKeyboard)

            val isPremium = true // settings.getBoolean(key = Constants.IS_PREMIUM, defaultValue = false)

            val request = searchUseCaseProvider.buildLocalSearchRequestUseCase(
                state = currentState,
                originalExpression = originalExpression,
                regex = regex,
                searchedChapters = searchedChapters,
                isPremium = isPremium,
            )

            var progress = 0

            val result = withContext(IoDispatcher) {
                searchUseCaseProvider.executeLocalSearchUseCase(
                    request = request,
                    shouldKeepRunning = {
                        immediateKeepRunning.value && generation == searchGeneration.value
                    },
                    onProgress = { book, chapter, resultsCount ->
                        progress++

                        dispatch(
                            SearchAction.SearchProgressChanged.Regular(
                                book = book,
                                chapter = chapter,
                                resultsCount = resultsCount,
                                progress = progress,
                                totalChapters = searchedChapters.size,
                            )
                        )
                    },
                    onResultsFound = { results ->
                        dispatch(
                            SearchAction.SearchResultsFound(
                                results = results,
                                generation = generation,
                            ),
                        )
                    },
                    buildTerminationMessage = { stringResource ->
                        stringResource.toSearchTerminationMessage()
                    },
                    buildErrorMessage = { _, debug ->
                        toSearchErrorMessage(debug)
                    },
                )
            }

            handleLocalSearchResult(result, generation)
        }
    }

    private suspend fun handleLocalSearchResult(
        result: LocalSearchResult,
        generation: Int,
    ) {
        val cancelledByUser = when (result) {
            is LocalSearchResult.Completed -> result.wasInterrupted
            is LocalSearchResult.Failure -> false
        }

        trackSearchAnalytics(
            query = currentState.query,
            searchMode = currentState.searchMode.name,
            searchPlace = currentState.searchPlace.name,
            withNikud = currentState.withNikud,
            withTeamim = currentState.withTeamim,
            onlyQri = currentState.onlyQri,
            resultsCount = result.resultsCount,
            durationMs = durationMs,
            cancelledByUser = cancelledByUser,
        )

        when (result) {
            is LocalSearchResult.Completed -> {
                handleLocalSearchCompleted(result, generation)
            }

            is LocalSearchResult.Failure -> {
                dispatch(
                    SearchAction.SearchFailed(
                        message = result.message.desc(),
                    ),
                )
            }
        }
    }

    private suspend fun handleLocalSearchCompleted(
        result: LocalSearchResult.Completed,
        generation: Int,
    ) {
        val wasCancelled = result.wasInterrupted

        sideEffectFlow.emit(SearchEffect.Vibrate(milliseconds = 100))
        sideEffectFlow.emit(SearchEffect.ShowMessage(result.message))

        // The run's own count: the SearchResultsFound actions may not be reduced into the state
        // yet, so currentState.results can still be empty for a search that did find results.
        if (!wasCancelled) {
            searchUseCaseProvider.getPostSearchSuggestionsUseCase(
                originalExpression = currentState.query,
                resultsCount = result.resultsCount,
            ).forEach { suggestion ->
                dispatch(
                    SearchAction.SearchSuggestionFound(
                        searchSuggestion = suggestion,
                    ),
                )
            }
        }

        dispatch(
            SearchAction.SearchCompleted(
                regex = result.finalRegex,
                resultsCount = result.resultsCount,
                differentVersesCount = result.differentVersesNum,
                generation = generation,
            ),
        )
    }

    private fun StringResource.toSearchTerminationMessage(): StringDesc {
        val durationSeconds = durationMs / 1000.0

        return searchUseCaseProvider.buildSearchTerminationMessageUseCase(
            stringResource = this,
            durationSeconds = durationSeconds,
        )
    }

    private fun trackSearchAnalytics(
        query: String,
        searchMode: String,
        searchPlace: String,
        withNikud: Boolean,
        withTeamim: Boolean,
        onlyQri: Boolean,
        resultsCount: Int,
        durationMs: Long,
        cancelledByUser: Boolean,
    ) {
        launchEffect {
            val event = searchAnalyticsEventFactory.createSearchEvent(
                query = query,
                searchMode = searchMode,
                searchPlace = searchPlace,
                withNikud = withNikud,
                withTeamim = withTeamim,
                onlyQri = onlyQri,
                resultsCount = resultsCount,
                durationMs = durationMs,
                cancelledByUser = cancelledByUser,
                source = runningSearchSource,
            )

            searchAnalyticsTracker.trackSearch(
                event = event,
            )
        }
    }

    private fun toSearchErrorMessage(
        debug: SearchDebugContext,
    ): String =
        buildString {
            appendLine("regex: ${debug.regex}")
            appendLine("book: ${debug.bookName}")
            appendLine("chapter: ${debug.chapterName}")
            appendLine()
            appendLine("ERROR:")
            appendLine(toString())
        }

    @OptIn(ExperimentalContracts::class)
    private inline fun <T> Result<T>.onSearchCompletion(action: (value: T?) -> Unit): Result<T> {
        contract {
            callsInPlace(action, InvocationKind.EXACTLY_ONCE)
        }
        action(getOrNull())
        return this
    }
}
